export default __webpack_public_path__ + "static/media/flips_2024_cover.ff5fe9c6.png";